/**
 * @file index.js
 * @author Fernando Ruano
 * @description Initialize Nutritional Indicator List List View.
 */

// Commons
import {
  mapStateToProps,
  mapDispatchToProps
} from '@nephro/commons/mapReduxCRUD/index';

// Dependencies
import { connect } from 'react-redux';

// View
import View from './NutritionalIndicatorListView';

export const mapStateToPropsNutritionalIndicatorList = mapStateToProps;
export const mapDispatchToPropsNutritionalIndicatorList = mapDispatchToProps;

export default connect(
  mapStateToPropsNutritionalIndicatorList,
  mapDispatchToPropsNutritionalIndicatorList
)(View);
